import styled from 'styled-components';
import {color} from '../../theme/variables';

export const StyledSeparator = styled.div`
  width: 100%;
  height: 1px;
  background: ${color.neutral};
`;